import { Button, CIActionGuard, CIListFilter, Dropdown, SearchInput, useUserPermission } from 'ccs-ui-components';
import React, { ChangeEvent, Dispatch, SetStateAction, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { requiredAuthPermission } from '../../../../../common/constants/UserPermissionConstants';
import useLoader from '../../../../../common/hooks/Loader';
import { IServiceScheduleMaintenance } from '../../../../models';
import classes from '../MaintenanceList.module.scss';

export interface InnerDropInterface {
  item: IServiceScheduleMaintenance;
  handleInnerCheckboxChange: (
    name: string,
    item: IServiceScheduleMaintenance,
  ) => void;
  setSelectedState: any;
  setShowUpdateModal: any;
  setSelectedItem: any;
}
export const InnerDrop: React.FC<InnerDropInterface> = ({
  item,
  handleInnerCheckboxChange,
  setSelectedState,
  setShowUpdateModal,
  setSelectedItem
}) => {
  const { t: translate } = useTranslation();
  const maintenanceScheduled: { value?: string; name: string }[] = [
    { value: 'SCHEDULED', name: translate('sm_table_helper.txt_scheduled') },
    { value: 'IN PROGRESS', name: translate('sm_table_helper.txt_in_progress') },
    { value: 'COMPLETED', name: translate('sm_table_helper.txt_completed') },
  ];
  const maintenanceInProgress: { value?: string; name: string }[] = [
    { value: 'IN PROGRESS', name: translate('sm_table_helper.txt_in_progress') },
    { value: 'COMPLETED', name: translate('sm_table_helper.txt_completed') },
  ];
  const exceptionTypeChangeHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedItem(item);
    const selectedValue = e.target.value;
    if (selectedValue === 'COMPLETED') {
      setShowUpdateModal(true);
      setSelectedState(selectedValue);
    } else {
      handleInnerCheckboxChange(selectedValue, item);
    }
  };
  return (
    <div className={classes.dropdown}>
      <Dropdown
        label=""
        data={item.maintenanceStatus === 'IN PROGRESS' ? maintenanceInProgress : maintenanceScheduled}
        className={classes['dropdown-control']}
        value={item.maintenanceStatus}
        onChange={exceptionTypeChangeHandler}
        data-testid="maintenance-dropdown"
        disabled={item.maintenanceStatus === 'COMPLETED'}
      />
    </div>
  );
};

interface FilterInterface {
  setPageDefault: () => void;
  setPage: (value: React.SetStateAction<number>) => void;
  setQueryParams: (
    value: React.SetStateAction<{
      [key: string]: string;
    }>
  ) => void;
  payloadDispatch: (
    search: string,
    status: string,
    columnId: string,
    sortType: string
  ) => void;
  searchValue: string;
  status: string;
  handleCheckboxChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleClearAction: () => void;
  sortedObj: { sortedName: string, sortedOrder: string }
  applyEnabled: boolean;
  setApplyEnabled: Dispatch<SetStateAction<boolean>>;
  addBtnHandler: (e: any) => void;
}
export const HeadFilters: React.FC<FilterInterface> = ({
  setPageDefault,
  setPage,
  setQueryParams,
  status,
  payloadDispatch,
  searchValue,
  handleCheckboxChange,
  handleClearAction,
  sortedObj,
  applyEnabled,
  setApplyEnabled,
  addBtnHandler
}) => {
  const { t: translate } = useTranslation();
  const loader = useLoader();

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setApplyEnabled(true);
    setPageDefault();
    setPage(0);
    setQueryParams((pre: any) => ({
      ...pre,
      search: e.target.value,
      status: status ?? ''
    }));
    payloadDispatch(
      e.target.value,
      status,
      sortedObj.sortedName,
      sortedObj.sortedOrder
    );
  };
  const handleFilterAction = () => {
    loader.show();
    setPageDefault();
    setQueryParams((pre: any) => ({
      ...pre,
      status,
      search: searchValue
    }));
    payloadDispatch(
      searchValue,
      status,
      sortedObj.sortedName,
      sortedObj.sortedOrder
    );
    setApplyEnabled(false);
  };

  useEffect(() => {
    if (status) {
      setApplyEnabled(true);
    } else {
      setApplyEnabled(false);
    }
  }, [status]);

  const clearAllHandler = () => {
    handleClearAction?.();
  };

  const applyClickHandler = () => {
    handleFilterAction?.call(null);
  };

  const { permissionObject } = useUserPermission();
  return (
    <div className={classes['filter-div']}>
      <div className={classes['search-filter-div']}>
        <CIListFilter applyEnabled={applyEnabled} onClear={clearAllHandler} onApply={applyClickHandler}>
          <Row>
            <Col>
              <div className={classes['status-component']}>
                <Dropdown
                  label=""
                  labelText={String(translate('sm_table_helper.txt_dropdown_label'))}
                  data={[
                    { name: translate('sm_table_helper.txt_scheduled'), value: 'SCHEDULED' },
                    { name: translate('sm_table_helper.txt_in_progress'), value: 'IN PROGRESS' },
                    { name: translate('sm_table_helper.txt_completed'), value: 'COMPLETED' }
                  ]}
                  className={classes['dropdown-control']}
                  value={status}
                  name="mainStatusType"
                  onChange={handleCheckboxChange}
                  data-testid="mainStatusType"
                  placeholder={String(translate('fsm_registry_form.lbl_placeholder_select'))}
                />
              </div>
            </Col>
          </Row>
        </CIListFilter>
        <div className={classes['input-wrapper']}>
          <SearchInput
            type="search"
            label="search"
            placeholder={String(translate('sm_table_helper.txt_search_placeholder'))}
            data-testid="search"
            id="jad-search-input"
            onChange={handleSearch}
            value={searchValue}
          />
        </div>
      </div>
      <div className={classes['add-maintenance']}>
        {CIActionGuard([requiredAuthPermission.Maintainence.edit], permissionObject.permission)
          && (
            <Button
              onClick={addBtnHandler}
            >
              {translate('sm_table_helper.txt_add_sm_btn')}
            </Button>
          )}
      </div>
    </div>
  );
};
